import { useMemo } from "react";
import { SurfaceChart } from "../ChartBlocks.jsx";
import { STIPPLE_SIZE, STIPPLE_DOT_RADIUS } from "../../lib/stipple.js";
import { KernelEmpty, extractSeries } from "./shared.jsx";

export const kind = "sparkline";

export function Component({ spec, data, fillHeight = false }) {
    const series = useMemo(() => extractSeries(data, spec.series), [data, spec.series]);
    if (!series.length) return <KernelEmpty message={spec.empty || "no data"} />;
    const height = Math.max(20, Math.min(160, Number(spec.height) || 40));
    const outerClass = fillHeight ? "flex h-full min-h-0 flex-col space-y-[3px]" : "space-y-[3px]";
    const chartWrapperClass = fillHeight ? "flex-1 min-h-0" : "";
    return (
        <div className={outerClass}>
            {spec.label ? (
                <div className="text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)]">
                    {spec.label}
                </div>
            ) : null}
            <div className={chartWrapperClass}>
                <SurfaceChart
                    mode="line"
                    series={series}
                    stroke={spec.color || "var(--ink)"}
                    fill={spec.color || "var(--ink)"}
                    className="relative w-full h-full text-[color:var(--plot-ink-soft)] border border-[color:var(--line)] bg-[color:var(--plot-bg)] rounded-[2px]"
                    padding={4}
                    width={420}
                    height={height}
                    strokeWidth={1.3}
                    haloWidth={3}
                    fillPattern
                    fillPatternSize={STIPPLE_SIZE}
                    fillDotRadius={STIPPLE_DOT_RADIUS}
                    haloStroke="var(--bg)"
                />
            </div>
        </div>
    );
}
